/*
创建者 魏强（2018.01.25）
提供 自营 api
*/
import {post, post2} from 'utils/post';


/*
添加者 魏强(2018.07.7)
自营生活馆首页信息
*/
export function zyIndex() {
  return post2('/pc/index/self/living/center')
}




// WEBPACK FOOTER //
// ./src/api/self-support.js